
import { Vue, Component, Prop } from 'vue-property-decorator';
import SidePanel from '@/features/common/components/SidePanel.vue';
import { ProductivityTip } from '@/features/shipment/constants/productivityTips';

@Component({
  components: { SidePanel },
})
export default class TipInfoPanel extends Vue {
  @Prop({ required: true }) tip!: ProductivityTip;

  @Prop({ default: false }) showPanel!: boolean;

  private onPanelInput(val: boolean): void {
    if (!val) this.$emit('close');
  }
}
